import { createRouter, createWebHistory } from 'vue-router';
import { isMiniProgram, queryStringify } from 'cfmoto-utils';
import beforeEach from './beforeEach';
import loading from '@/components/loading/index';

const requireModules = require.context('./modules', true, /(.js$)/);
const routes = requireModules
  .keys()
  .map((filePath) => requireModules(filePath).default)
  .flat();

// console.log(requireModules.keys().map((filePath) => requireModules(filePath).default));
const router = createRouter({
  history: createWebHistory('/app'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    console.log(savedPosition);
    return { left: 0, top: 0 };
  },
});
beforeEach.forEach((item) => {
  router.beforeEach(item);
});

// 路由切换成功
router.afterEach((route) => {
  console.log('afterEach');
  const meta = route.meta || {};
  document.title = meta.title || '';
  document.body.className = meta.backgroundClass || '';
  // store.commit(SET_TITLE, meta.title || '');

  setTimeout(() => {
    loading.clear();
  }, 200);
});

const { push, replace, back, go } = router;
const pattern = /\/(index.html)?#\//;
router.go = function nativeBack(options) {
  const originCurrent = (window.history.state || {}).current || '';
  const current = originCurrent.replace(pattern, '/');
  go.apply(this, [options]);
  setTimeout(() => {
    const originBackCurrent = (window.history.state || {}).current || '';
    const backCurrent = originBackCurrent.replace(pattern, '/');
    if (current === backCurrent && window.cfmoto.isNativeEnv) {
      window.cfmoto.navigateBack({ delta: 1 });
    }
  }, 10);
};

/* eslint-disable no-proto */
router.back = function nativeBack(options) {
  const originCurrent = (window.history.state || {}).current || '';
  const current = originCurrent.replace(pattern, '/');
  back.apply(this, [options]);
  setTimeout(() => {
    const originBackCurrent = (window.history.state || {}).current || '';
    const backCurrent = originBackCurrent.replace(pattern, '/');
    if (current === backCurrent && window.cfmoto.isNativeEnv) {
      window.cfmoto.navigateBack({ delta: 1 });
    }
  }, 10);
};
router.push = function nativePush(options) {
  const newOptions = this.resolve(JSON.parse(JSON.stringify(options)));
  const { params, query, meta } = newOptions;
  const { isMiniapp } = window.app || {};
  const token = JSON.parse(window.localStorage.getItem('token ') || '""');
  console.log('======= push');
  console.log(newOptions);
  console.log('==== android');
  console.log(window.android);
  // console.log({ ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) });
  // 小程序发送token更换再切换路由
  if (isMiniapp && meta.miniUrl) {
    const appData = { type: 'changeToken', data: { token } };
    const queryData = Object.assign(params, query);
    const queryStr = Object.keys(queryData)
      .map((key) => `${key}=${queryData[key]}`)
      .join('&');
    window.wx.miniProgram.postMessage(JSON.stringify(appData));
    window.wx.miniProgram.navigateTo({ url: `${meta.miniUrl}${queryStr ? `?${queryStr}` : ''}` });
    return;
  }
  if (window.cfmoto.isNativeEnv && meta.appName) {
    const queryData = { ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) };
    window.cfmoto.navigateTo({ url: meta.appName, query: queryData });
    return;
  }

  return push.apply(this, [options]);
};

router.replace = function nativeReplace(options) {
  console.log(options);
  // const routeOptions = JSON.parse(JSON.stringify(options));
  const newOptions = this.resolve(JSON.parse(JSON.stringify(options)));
  const { params, query, meta } = newOptions;
  const token = JSON.parse(window.localStorage.getItem('token ') || '""');
  // 小程序发送token更换再切换路由
  if (isMiniProgram() && meta.miniUrl) {
    const appData = { type: 'changeToken', data: { token } };
    const queryStr = queryStringify({ ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) });
    window.wx.miniProgram.postMessage(JSON.stringify(appData));
    window.wx.miniProgram.navigateTo({ url: `${meta.miniUrl}${queryStr ? `?${queryStr}` : ''}` });
    return;
  }
  if (window.cfmoto.isNativeEnv && meta.appName) {
    const queryData = { ...JSON.parse(JSON.stringify(params)), ...JSON.parse(JSON.stringify(query)) };
    window.cfmoto.redirectTo({ url: meta.appName, query: queryData });
    return;
  }
  return replace.apply(this, [options]);
};

export default router;
